import { BannerSlider } from './BannerSlider';

export function Banner({ data }) {
    return (
        <div className='banner'>
            <BannerSlider
                imagesMobile={data.bannerImagesMobile}
                imagesDesktop={data.bannerImagesDesktop}
                descriptionImages={data.bannerImageDescription}
                titles={data.bannerTitle}
                subtitles={data.bannerDescription} />
        </div>
    );
}